import { useState, useEffect } from 'react'

export const useLocationTracking = () => {
  const [locationState, setLocationState] = useState<google.maps.LatLngLiteral>()

  useEffect(() => {
    if (!navigator.geolocation) {
      console.log('Geolocation is not supported by your browser.')
      return
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    }
    // Request permission and get location
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords
        // console.log('Current Location:', { latitude, longitude })
        // Update your state/map here
        setLocationState({
          lat: latitude,
          lng: longitude,
        })
      },
      (error) => {
        console.warn(error)
      },
      options
    )
  }, [])

  return locationState
}